import React, { useState, useEffect } from 'react';
import styles from './NotificationCard.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import { useHistory } from 'react-router-dom';

const NotificationCard = ({
  id,
  title,
  message,
  onClose,
  shadow,
  wrapper,
  queryParams,
  status,
  index,
  totalNotifications,
  isNew,
  autoClose,
  opponent,
  forceExit,
}) => {
  const history = useHistory();
  const [animationState, setAnimationState] = useState('');

  useEffect(() => {
    if (isNew) {
      setAnimationState('slideIn');
    }
  }, [isNew]);

  const getUrl = (queryParams) => {
    if (status === 'chat' || status === 'order' || status === 'request') {
      history.push(`/inbox/chat/${queryParams}`);
    } else {
      history.push(`/inventory/emptyDropped/appointments?${queryParams}`);
    }
  };

  const handleClose = () => {
    setAnimationState('exiting');
    setTimeout(() => {
      onClose(id);
    }, 300);
  };

  useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        handleClose();
      }, 5000);
    }
  }, [autoClose]);
  // console.log('opponent', opponent);
  return (
    <div
      className={`${styles.card} ${
        animationState ? styles[animationState] : ''
      } ${forceExit ? styles.exiting : ''}`}>
      <div
        className={styles.closeButton}
        onClick={(e) => {
          e.stopPropagation();
          handleClose();
        }}>
        <ReactSVG src={Icons.xIconBlack} />
      </div>
      <span
        className={styles.toastBody}
        onClick={(e) => {
          if (queryParams) {
            getUrl(queryParams);
            handleClose();
          } else {
            handleClose();
          }
        }}>
        <div className={styles.cardHeader}>
          <div
            className={styles.shadow}
            style={
              title?.toLowerCase().includes('new reservation')
                ? { backgroundColor: '#EFF0F2' }
                : title?.toLowerCase().includes('reservation pre-approved')
                ? { backgroundColor: '#EBF1FF' }
                : title?.toLowerCase().includes('new message')
                ? { backgroundColor: '#EFF0F2' }
                : title?.toLowerCase().includes('reservation approved')
                ? { backgroundColor: '#E0FAEC' }
                : title?.toLowerCase().includes('reservation declined') ||
                  title?.toLowerCase().includes('reservation rejected') ||
                  title
                    ?.toLowerCase()
                    .includes('pre-approved containers canceled') ||
                  title
                    ?.toLowerCase()
                    .includes('pre-approved containers declined') ||
                  title
                    ?.toLowerCase()
                    .includes('approved containers disputed') ||
                  title?.toLowerCase().includes('reservation cancelled') ||
                  title?.toLowerCase().includes('reservation canceled')
                ? { backgroundColor: 'FFEBEC' }
                : { backgroundColor: shadow }
            }>
            <div
              className={styles.iconWrapper}
              style={
                title?.toLowerCase().includes('new reservation')
                  ? { backgroundColor: '#717784' }
                  : title?.toLowerCase().includes('reservation pre-approved')
                  ? { backgroundColor: '#335CFF' }
                  : title?.toLowerCase().includes('new message')
                  ? { backgroundColor: '#717784' }
                  : title?.toLowerCase().includes('reservation approved')
                  ? { backgroundColor: '#1FC16B' }
                  : title?.toLowerCase().includes('reservation declined') ||
                    title?.toLowerCase().includes('reservation rejected') ||
                    title
                      ?.toLowerCase()
                      .includes('pre-approved containers canceled') ||
                    title
                      ?.toLowerCase()
                      .includes('pre-approved containers declined') ||
                    title
                      ?.toLowerCase()
                      .includes('approved containers disputed') ||
                    title?.toLowerCase().includes('reservation cancelled') ||
                    title?.toLowerCase().includes('reservation canceled')
                  ? { backgroundColor: '#FB3748' }
                  : { backgroundColor: wrapper }
              }>
              <ReactSVG src={Icons.whiteBell} className={styles.icon} />
            </div>
          </div>
          <h3 className={styles.title}>
            {title?.toLowerCase().includes('new message')
              ? `${title} from ${opponent?.company}`
              : title}
          </h3>
        </div>
        <p className={styles.message}>
          {title?.toLowerCase().includes('new message')
            ? `${opponent?.name} : ` + message
            : message}
        </p>
      </span>
    </div>
  );
};

export default NotificationCard;
